var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBeneficiarioNonAttendibile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "prefix__a",
    d: "M12.09 15c1.607 0 2.91 1.304 2.91 2.912V21H0v-3.088C0 16.304 1.303 15 2.91 15h9.18zM7.777 0C10.661 0 13 2.146 13 4.792v3.416C13 10.855 10.661 13 7.777 13h-.555C4.338 13 2 10.855 2 8.208V4.792C2 2.146 4.338 0 7.222 0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(15 10)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "prefix__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#prefix__a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#0B0B0A",
    xlinkHref: "#prefix__a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#3F3F3F",
    mask: "url(#prefix__b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H44V44H0z",
    transform: "translate(-15 -10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiarioNonAttendibile);
export default __webpack_public_path__ + "static/media/beneficiario-non-attendibile.124301e89bf249c53abda15e760945cd.svg";
export { ForwardRef as ReactComponent };